import React from 'react';
// import Intro from "./intro";
// const shopSvg = "https://variety.com/wp-content/uploads/2020/09/sony-playstation-5.png?w=1024";

export default function Banner() {

    return (
        <div className="banner-section">
            <div className="info">
                <h1>Trace Mall</h1>
                <p>Shop Like Kings & Queens</p>
            </div>
        </div>
    );
}